import React from 'react';
import { generatePath } from 'react-router';
import styled from 'styled-components';

import { Divider } from '@xingternal/divider';
import { space4XL, spaceL } from '@xingternal/tokens';
import { Hero } from '@xingternal/typography';

import { DirectoryList, DirectorySection } from '@/components/_common/directory';
import { routes, serpsRoutes } from '@/config';

import CitiesList from './data/seo_cities.json';
import TermsList from './data/seo_terms.json';

const StyledHero = styled(Hero)`
  text-transform: uppercase;
  margin-top: ${space4XL};
  margin-bottom: ${spaceL};
`;

type Props = {
  letter: string;
};

const normalizeCategoryValue = (value: string): string =>
  encodeURIComponent(value.replaceAll(' ', '-').toLocaleLowerCase());

const filterList = (list: string[], letter: string): string[] =>
  list.filter((city) => city.toLowerCase().charAt(0) === letter);

export const JobsDirectory: React.FC<Props> = ({ letter }) => {
  const cities = filterList(CitiesList.cities, letter);
  const terms = filterList(TermsList.terms, letter);

  return (
    <>
      <DirectoryList
        titleTranslationKey="XJM_SEO_DIRECTORY_PAGINATION_H"
        letter={letter}
        route={routes.jobsDirectory}
      />
      <StyledHero forwardedAs="h2" size="large">
        {letter}
      </StyledHero>
      <Divider />
      <DirectorySection
        titleTranslationKey="JOB_DIRECTORY_CITIES_H"
        list={cities}
        generateLinkProps={(item: string) => {
          return { to: generatePath(serpsRoutes.city, { categoryValue: normalizeCategoryValue(item) }), copy: item };
        }}
      />
      <DirectorySection
        titleTranslationKey="JOB_DIRECTORY_OTHERS_H"
        list={terms}
        generateLinkProps={(item: string) => {
          return { to: generatePath(serpsRoutes.role, { categoryValue: normalizeCategoryValue(item) }), copy: item };
        }}
      />
    </>
  );
};
